import type { nav as navEn } from "../en/nav";

export const nav: typeof navEn = {
  sections: {
    myDay: "Můj den",
    inbox: "Inbox",
    sales: "Prodej",
    operations: "Provoz",
    finance: "Finance",
    content: "Obsah",
    marketing: "Marketing",
    system: "Systém",
  },
  items: {
    dashboard: "Přehled",
    inbox: "Inbox",
    inquiries: "Poptávky",
    orders: "Objednávky",
    customers: "Zákazníci",
    serviceQueue: "Fronta služeb",
    flightDesk: "Letenky",
    season: "Sezóna",
    schedule: "Harmonogram",
    departures: "Termíny",
    calendar: "Kalendář",
    documents: "Dokumenty",
    complaints: "Reklamace",
    suppliers: "Dodavatelé",
    serviceCatalog: "Katalog služeb",
    templates: "Šablony",
    invoices: "Faktury",
    payments: "Platby a marže",
    vouchers: "Poukazy",
    destinations: "Destinace",
    guides: "Průvodci",
    destinationTeams: "Kontakty a týmy",
    trips: "Zájezdy",
    tripOrder: "Pořadí zájezdů",
    upgrades: "Upgrady",
    inspirations: "Inspirace",
    faq: "FAQ",
    jobOffers: "Pracovní nabídky",
    holidays: "Svátky a prázdniny",
    podcastEpisodes: "Podcasty",
    blog: "Blog",
    contentPages: "Stránky",
    reviews: "Recenze",
    googleReviews: "Google recenze",
    quiz: "Kvíz",
    homepage: "Úvodní stránka",
    promoBar: "Horní lišta",
    media: "Média",
    newsletterStudio: "Newsletter",
    automations: "Automatizace",
    journeys: "Journeys",
    analytics: "Analytika",
    wiki: "Wiki",
    countryKb: "Znalosti zemí",
    auditLog: "Audit log",
    users: "Uživatelé",
    integrations: "Integrace",
  },
};
